<template>
    <div>
        <div class="container-fluid mt-4">
            <div class="top-popup-holder">
                <div class="top-popup" @click="showPopup = !showPopup">

                    <div class="d-flex">
                        <div class="top-gift-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.75 16.875H6.75V18.75H3.75V16.875Z" fill="black"/>
                                <path d="M22.125 6.0019H19.95C20.1763 5.5249 20.2791 4.99866 20.2489 4.47156C20.2187 3.94445 20.0566 3.43339 19.7773 2.98534C19.498 2.53729 19.1106 2.16663 18.6506 1.90741C18.1907 1.6482 17.6729 1.50876 17.145 1.5019C15.5893 1.4639 14.0737 1.99757 12.885 3.0019C12.5471 3.29654 12.2495 3.63446 12 4.0069C11.7505 3.63446 11.4529 3.29654 11.115 3.0019C9.92633 1.99757 8.41069 1.4639 6.855 1.5019C6.32708 1.50876 5.80935 1.6482 5.34939 1.90741C4.88944 2.16663 4.50201 2.53729 4.22273 2.98534C3.94344 3.43339 3.78126 3.94445 3.75108 4.47156C3.72089 4.99866 3.82368 5.5249 4.05 6.0019H1.875C1.37772 6.0019 0.900805 6.19944 0.549175 6.55107C0.197544 6.9027 0 7.37962 0 7.8769L0 20.6269C0 21.1242 0.197544 21.6011 0.549175 21.9527C0.900805 22.3044 1.37772 22.5019 1.875 22.5019H22.125C22.6223 22.5019 23.0992 22.3044 23.4508 21.9527C23.8025 21.6011 24 21.1242 24 20.6269V7.8769C24 7.37962 23.8025 6.9027 23.4508 6.55107C23.0992 6.19944 22.6223 6.0019 22.125 6.0019ZM14.13 4.4119C14.9711 3.71403 16.0375 3.34614 17.13 3.3769C17.4682 3.3769 17.7925 3.51123 18.0316 3.75034C18.2707 3.98945 18.405 4.31375 18.405 4.6519C18.405 4.99005 18.2707 5.31435 18.0316 5.55346C17.7925 5.79257 17.4682 5.9269 17.13 5.9269H13.11C13.3077 5.33944 13.6601 4.8161 14.13 4.4119ZM6.855 3.3769C7.94751 3.34614 9.01387 3.71403 9.855 4.4119C10.3227 4.81196 10.6749 5.32987 10.875 5.9119H6.855C6.51685 5.9119 6.19255 5.77757 5.95344 5.53846C5.71433 5.29935 5.58 4.97505 5.58 4.6369C5.58 4.29875 5.71433 3.97445 5.95344 3.73534C6.19255 3.49623 6.51685 3.3619 6.855 3.3619V3.3769ZM1.875 7.8769H22.125V9.7519H1.875V7.8769ZM1.875 20.6269V13.5019H22.125V20.6269H1.875Z" fill="black"/>
                            </svg>
                        </div>
                        <div class="popup-description">
                            <h3>Complete this task to earn more points</h3>
                            <h4>Your reward for being a smart landlord</h4>
                        </div>

                    </div>
                    <div>
                        <span><i class="fa" :class="[showPopup ? 'fa-chevron-up' : 'fa-chevron-down']"></i></span>
                    </div>
                </div>

                <div v-if="showPopup">
                    <div class="popup-body">
                        <div class="d-flex">
                            <div class="description-gift-icon mr-2 d-none d-md-block">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.75 16.875H6.75V18.75H3.75V16.875Z" fill="black"/>
                                    <path d="M22.125 6.0019H19.95C20.1763 5.5249 20.2791 4.99866 20.2489 4.47156C20.2187 3.94445 20.0566 3.43339 19.7773 2.98534C19.498 2.53729 19.1106 2.16663 18.6506 1.90741C18.1907 1.6482 17.6729 1.50876 17.145 1.5019C15.5893 1.4639 14.0737 1.99757 12.885 3.0019C12.5471 3.29654 12.2495 3.63446 12 4.0069C11.7505 3.63446 11.4529 3.29654 11.115 3.0019C9.92633 1.99757 8.41069 1.4639 6.855 1.5019C6.32708 1.50876 5.80935 1.6482 5.34939 1.90741C4.88944 2.16663 4.50201 2.53729 4.22273 2.98534C3.94344 3.43339 3.78126 3.94445 3.75108 4.47156C3.72089 4.99866 3.82368 5.5249 4.05 6.0019H1.875C1.37772 6.0019 0.900805 6.19944 0.549175 6.55107C0.197544 6.9027 0 7.37962 0 7.8769L0 20.6269C0 21.1242 0.197544 21.6011 0.549175 21.9527C0.900805 22.3044 1.37772 22.5019 1.875 22.5019H22.125C22.6223 22.5019 23.0992 22.3044 23.4508 21.9527C23.8025 21.6011 24 21.1242 24 20.6269V7.8769C24 7.37962 23.8025 6.9027 23.4508 6.55107C23.0992 6.19944 22.6223 6.0019 22.125 6.0019ZM14.13 4.4119C14.9711 3.71403 16.0375 3.34614 17.13 3.3769C17.4682 3.3769 17.7925 3.51123 18.0316 3.75034C18.2707 3.98945 18.405 4.31375 18.405 4.6519C18.405 4.99005 18.2707 5.31435 18.0316 5.55346C17.7925 5.79257 17.4682 5.9269 17.13 5.9269H13.11C13.3077 5.33944 13.6601 4.8161 14.13 4.4119ZM6.855 3.3769C7.94751 3.34614 9.01387 3.71403 9.855 4.4119C10.3227 4.81196 10.6749 5.32987 10.875 5.9119H6.855C6.51685 5.9119 6.19255 5.77757 5.95344 5.53846C5.71433 5.29935 5.58 4.97505 5.58 4.6369C5.58 4.29875 5.71433 3.97445 5.95344 3.73534C6.19255 3.49623 6.51685 3.3619 6.855 3.3619V3.3769ZM1.875 7.8769H22.125V9.7519H1.875V7.8769ZM1.875 20.6269V13.5019H22.125V20.6269H1.875Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="popup-description-body">
                                <h5>Complet profile <span>09:23 <small>Time left</small></span></h5>
                                <h6>1000 Points, <span>will be earned when you respond to this request before time elapse.</span></h6>
                            </div>
                        </div>
                        <div class="claimbtn-holder">
                            <button class="btn">Claim</button>
                        </div>
                    </div>

                    <div class="popup-body">
                        <div class="d-flex">
                            <div class="description-gift-icon mr-2 d-none d-md-block">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.75 16.875H6.75V18.75H3.75V16.875Z" fill="black"/>
                                    <path d="M22.125 6.0019H19.95C20.1763 5.5249 20.2791 4.99866 20.2489 4.47156C20.2187 3.94445 20.0566 3.43339 19.7773 2.98534C19.498 2.53729 19.1106 2.16663 18.6506 1.90741C18.1907 1.6482 17.6729 1.50876 17.145 1.5019C15.5893 1.4639 14.0737 1.99757 12.885 3.0019C12.5471 3.29654 12.2495 3.63446 12 4.0069C11.7505 3.63446 11.4529 3.29654 11.115 3.0019C9.92633 1.99757 8.41069 1.4639 6.855 1.5019C6.32708 1.50876 5.80935 1.6482 5.34939 1.90741C4.88944 2.16663 4.50201 2.53729 4.22273 2.98534C3.94344 3.43339 3.78126 3.94445 3.75108 4.47156C3.72089 4.99866 3.82368 5.5249 4.05 6.0019H1.875C1.37772 6.0019 0.900805 6.19944 0.549175 6.55107C0.197544 6.9027 0 7.37962 0 7.8769L0 20.6269C0 21.1242 0.197544 21.6011 0.549175 21.9527C0.900805 22.3044 1.37772 22.5019 1.875 22.5019H22.125C22.6223 22.5019 23.0992 22.3044 23.4508 21.9527C23.8025 21.6011 24 21.1242 24 20.6269V7.8769C24 7.37962 23.8025 6.9027 23.4508 6.55107C23.0992 6.19944 22.6223 6.0019 22.125 6.0019ZM14.13 4.4119C14.9711 3.71403 16.0375 3.34614 17.13 3.3769C17.4682 3.3769 17.7925 3.51123 18.0316 3.75034C18.2707 3.98945 18.405 4.31375 18.405 4.6519C18.405 4.99005 18.2707 5.31435 18.0316 5.55346C17.7925 5.79257 17.4682 5.9269 17.13 5.9269H13.11C13.3077 5.33944 13.6601 4.8161 14.13 4.4119ZM6.855 3.3769C7.94751 3.34614 9.01387 3.71403 9.855 4.4119C10.3227 4.81196 10.6749 5.32987 10.875 5.9119H6.855C6.51685 5.9119 6.19255 5.77757 5.95344 5.53846C5.71433 5.29935 5.58 4.97505 5.58 4.6369C5.58 4.29875 5.71433 3.97445 5.95344 3.73534C6.19255 3.49623 6.51685 3.3619 6.855 3.3619V3.3769ZM1.875 7.8769H22.125V9.7519H1.875V7.8769ZM1.875 20.6269V13.5019H22.125V20.6269H1.875Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="popup-description-body">
                                <h5>Complet profile <span>09:23 <small>Time left</small></span></h5>
                                <h6>1000 Points, <span>will be earned when you respond to this request before time elapse.</span></h6>
                            </div>
                        </div>
                        <div class="claimbtn-holder">
                            <button class="btn">Claim</button>
                        </div>
                    </div>

                    <div class="popup-body">
                        <div class="d-flex">
                            <div class="description-gift-icon mr-2 d-none d-md-block">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.75 16.875H6.75V18.75H3.75V16.875Z" fill="black"/>
                                    <path d="M22.125 6.0019H19.95C20.1763 5.5249 20.2791 4.99866 20.2489 4.47156C20.2187 3.94445 20.0566 3.43339 19.7773 2.98534C19.498 2.53729 19.1106 2.16663 18.6506 1.90741C18.1907 1.6482 17.6729 1.50876 17.145 1.5019C15.5893 1.4639 14.0737 1.99757 12.885 3.0019C12.5471 3.29654 12.2495 3.63446 12 4.0069C11.7505 3.63446 11.4529 3.29654 11.115 3.0019C9.92633 1.99757 8.41069 1.4639 6.855 1.5019C6.32708 1.50876 5.80935 1.6482 5.34939 1.90741C4.88944 2.16663 4.50201 2.53729 4.22273 2.98534C3.94344 3.43339 3.78126 3.94445 3.75108 4.47156C3.72089 4.99866 3.82368 5.5249 4.05 6.0019H1.875C1.37772 6.0019 0.900805 6.19944 0.549175 6.55107C0.197544 6.9027 0 7.37962 0 7.8769L0 20.6269C0 21.1242 0.197544 21.6011 0.549175 21.9527C0.900805 22.3044 1.37772 22.5019 1.875 22.5019H22.125C22.6223 22.5019 23.0992 22.3044 23.4508 21.9527C23.8025 21.6011 24 21.1242 24 20.6269V7.8769C24 7.37962 23.8025 6.9027 23.4508 6.55107C23.0992 6.19944 22.6223 6.0019 22.125 6.0019ZM14.13 4.4119C14.9711 3.71403 16.0375 3.34614 17.13 3.3769C17.4682 3.3769 17.7925 3.51123 18.0316 3.75034C18.2707 3.98945 18.405 4.31375 18.405 4.6519C18.405 4.99005 18.2707 5.31435 18.0316 5.55346C17.7925 5.79257 17.4682 5.9269 17.13 5.9269H13.11C13.3077 5.33944 13.6601 4.8161 14.13 4.4119ZM6.855 3.3769C7.94751 3.34614 9.01387 3.71403 9.855 4.4119C10.3227 4.81196 10.6749 5.32987 10.875 5.9119H6.855C6.51685 5.9119 6.19255 5.77757 5.95344 5.53846C5.71433 5.29935 5.58 4.97505 5.58 4.6369C5.58 4.29875 5.71433 3.97445 5.95344 3.73534C6.19255 3.49623 6.51685 3.3619 6.855 3.3619V3.3769ZM1.875 7.8769H22.125V9.7519H1.875V7.8769ZM1.875 20.6269V13.5019H22.125V20.6269H1.875Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="popup-description-body">
                                <h5>Complet profile <span>09:23 <small>Time left</small></span></h5>
                                <h6>1000 Points, <span>will be earned when you respond to this request before time elapse.</span></h6>
                            </div>
                        </div>
                        <div class="claimbtn-holder">
                            <button class="btn">Claim</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="safe-card mb-3">
                        <div class="safe-card-top">
                            <div class="">
                                <h3>Shelta reward</h3>
                            </div>
                        </div>
                        <p class="af">You've earned {{Number(newDasboard.data.today_rewards).toLocaleString()}} points today</p>

                        <div class="safe-amount">
                            <div class>
                                
                                <h3>{{ rewardVisibility ? Number(newDasboard.data.shelta_points).toLocaleString() : '**************'}}  <span v-if="rewardsData">{{(rewardsData.percentage_increase).toFixed(2)}}%</span> <span  v-if="rewardsData"><i class="fa fa-arrow-up"></i></span></h3>
                                <!-- <p>You've earned {{newDasboard.data.today_reward}} points today</p> -->
                            </div>
                            <div>
                                <span @click="rewardVisibility = !rewardVisibility"><i class="fa fa-eye"></i></span>
                            </div>
                        </div>

                        <div class="bank-details" style="margin-top: 40px;">
                            <!-- <div class="account-number">
                                <div>
                                    <button class="btn white-outline-btn">View more</button>
                                </div>
                            </div> -->
                            <div>
                                <button class="btn primaryBtn">Earn points</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-8">
                    <div class="safe-card mb-3 reward-section">
                        <h5>Complete task to earn more Shelta points : <span>Your reward for being a shelta user</span></h5>
                        <div class="reward-buttons-holder hide-scrollbar">
                            <div class="reward-buttons">
                                <h6>Complet profile setup</h6>
                                <button class="btn"> Earn 2000 points</button>
                            </div>
                            <div class="reward-buttons">
                                <h6>Upload tenant information</h6>
                                <button class="btn">Earn 1000 points</button>
                            </div>
                            <div class="reward-buttons">
                                <h6>Setup safe</h6>
                                <button class="btn">Earn 1000 points</button>
                            </div>
                            <div class="reward-buttons">
                                <h6>Upgarde safe</h6>
                                <button class="btn">Earn 2000 points</button>
                            </div>
                            <div class="reward-buttons">
                                <h6>Upgarde safe</h6>
                                <button class="btn">Earn 2000 points</button>
                            </div>
                            <div class="reward-buttons">
                                <h6>Upgarde safe</h6>
                                <button class="btn">Earn 2000 points</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="table-holder">
                    <h4 class="t-history">Points Earning History</h4>

                    <div class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Activity</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Point Earned</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody  v-for="(item, index) in rewardsData.rewards"
                                    :key="index">
                                <tr>
                                    <td>{{item.activity.type}}</td>
                                    <td>{{item.month_year}}</td>
                                    <td>{{ item.amount }}</td>
                                    <td><span :class="[item.transaction_type == 'credit' ? 'credit' : '', item.transaction_type == 'debit' ? 'debit' : '']">{{item.transaction_type}}</span></td>
                                </tr> 
                            </tbody>
                        </table>
                        <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                            <EmptyState :emptyData="emptyDataObject2" />
                        </div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import Header from "../views/Header";
// import FooterMain from "../views/FooterMain";
import { Service } from "../store/service";
const Api = new Service();
import { fetchNewLandlordDashboard } from './helpers';

export default {
  name: "SheltaRewardPoint",
  components: {
    // Header,
    // FooterMain,
    // PromoGif,
    // subscriptionModal
  },
  data() {
    return {
        rewardVisibility: false,
        showPopup: false,
        newDasboard: {
            data: {
                today_rewards: 0,
                shelta_points: 0,
                percentage_increase: 0,     
            }
        },
        rewardsData: "",
    };
  },
  async created() {
    await this.fetchNewDashboardFunc();
    // await this.createUser();
  },
  mounted() {
    this.fetchRewards();
  },
  methods: {
    moveTo() {
      this.$router
        .push({
          path: `/`
        })
        .catch(() => {});
    },
    async fetchNewDashboardFunc() {
        try {
            this.newDasboard = await fetchNewLandlordDashboard();
            // if (this.newDasboard.data.success) {
            //     console.log("Landlord Upcoming task", this.newDasboard);
            // }
            
        } catch (error) {
            console.error(error)
        }
    },

    async fetchRewards() {
        this.loading = true;
        await Api.getRequest(`shelta-rewards`)
        .then(data => {
            this.loading = false;
            // console.log("Rewards", data)
            if (data.data.success) {
                this.rewardsData = data.data;
            } else {
                this.$toast.error(data.error);
            }
        }).catch((err) => {
            this.loading = false;
            console.log(err);
            // this.$toast.error("please check your network and refresh the page");
        });
    },
  }
};
</script>


<style scoped lang="scss">


.safe-card {
    padding: 16px 25px;
    background: #ffffff;
    border-radius: 12px;
    min-height: 205px;
}

.safe-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        color: #00155F;
        margin-bottom: 0;
    }
}

.safe-amount {
    display: flex;
    justify-content: space-between;
    h3, small {
        font-family: Lato;
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;
        color: #374151;
        span {
            color: #2BC300;
            font-family: Lato;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            margin-left: 7px;
        }
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        line-height: 22px;
        color: #555C74;
        text-align: left;
    }
}

.account-number {
    display: flex;
    gap: 5px;
    text-align: left;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        // line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
}

.af {
    font-family: Lato;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    color: #374151;
    text-align: left;
    margin-top: 10px;
}
.bank-details {
    display: flex;
    // justify-content: space-between;
    justify-content: right;
}
input:disabled {
    background: inherit !important;
}
.white-outline-btn {
    border: 1px solid #D2D2D2;
    background: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    outline: 0;
    box-shadow: none;
}
.primaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}



.table-holder {
    background: #ffffff;
    padding: 30px 15px;
    margin-top: 30px;
}
.t-history {
    font-family: Lato;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #2B3352;
    text-align: left;
    margin-bottom: 20px;
}


.tableList {
    // margin-top: 30px;
    margin-bottom: 20px;
    border: 2px solid #EAECF0;
    border-radius: 8px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    background: #F3F4F6;
}
thead th {
    white-space: nowrap;
    text-align: left;
    color: #374151;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #374151;
    line-height: 24px;
}

tbody {
    tr {
        cursor: pointer;
    }
}

.credit {
    background: #84EBB4;
    border-radius: 50px;
    color: #374151;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}
.debit {
    background: #DFA052;
    border-radius: 50px;
    color: #333333;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}
.top-popup-holder {
    background: #D1DBFF;
    padding: 15px 15px 15px 15px;
    margin-bottom: 20px;
    border-radius: 4px;
}

.popup-description {
    text-align: left;
    margin-left: 10px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #2B3352;
        margin-bottom: 0;
    }
    h4 {
        font-family: Lato;
        font-weight: 400;
        font-style: Regular;
        font-size: 18px;
        line-height: 32px;
        color: #2B3352;
    }
}

.top-gift-icon {
    background: #ffffff;
    padding: 7px;
    border-radius: 50px;
    height: 40px;
    width: 40px;
}

.description-gift-icon {
    background: #D1DBFF;
    padding: 7px;
    border-radius: 50px;
    height: 40px;
    width: 40px;
}

.top-popup {
    display: flex;
    justify-content: space-between;
}
.popup-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
    background: #ffffff;
    padding: 12px 16px;
    border-radius: 8px;
    button {
        border: 1px solid #0033EA;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        color: #00155F;
        box-shadow: none;
        outline: 0;
    }
}

.popup-description-body {
    
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        line-height: 20px;
        color: #333333;
        text-align: left;
        span {
            padding-left: 10px;
            font-family: Lato;
            font-weight: 700;
            font-style: Bold;
            font-size: 10.83px;
            line-height: 14.45px;
            color: #FB3748;
            small {
                color: #92400E;
                font-size: 8px;
            }
        }
    }
    h6 {
        font-family: Lato;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        line-height: 20px;
        color: #0033EA;
        text-align: left;
        span {
            font-family: Lato;
            font-weight: 400;
            font-style: Regular;
            font-size: 14px;
            line-height: 20px;
            color: #333333;

        }

    }
}



.reward-section {
    min-height: 226px;
    h5 {
        text-align: left;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 26.95px;
        color: #2B3352;
        span {
            font-family: Lato;
            font-weight: 400;
            font-style: Regular;
            font-size: 14px;
            line-height: 26.95px;
        }
    }
}
.reward-buttons-holder {
    display: flex;
    overflow: scroll;
    white-space: nowrap;
    margin-top: 30px;
}

.reward-buttons {
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 5px;
    padding: 10px 20px;
    margin-right: 15px;
    h6 {
        font-family: Lato;
        font-weight: 700;
        font-style: Bold;
        font-size: 12px;
        line-height: 20px;
        color: #333333;
        text-align: left;
    }
    button {
        box-shadow: 0px 1px 2px 0px #0000000D;
        border: 1px solid #00155F;
        color: #0033EA;
        font-family: Lato;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 12px;
        line-height: 24px;
        outline: 0;
    }
}

.hide-scrollbar {
  overflow: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

@media only screen and (max-width: 599px) {
    .popup-body {
        display: block;
    }
    .claimbtn-holder {
        margin-top: 10px;
    }
}

</style>